const Search = function () {

  const searchUrl = '/wp-admin/admin-ajax.php?action=nexus_search&keyword=';
  const $searchBtn = $('#openSearch');
  const $searchCloseBtn = $('.menu-button');
  const $searchContainer = $('#searchContainer');
  const $searchContent = $searchContainer.find('.search-content');
  const $searchInput = $('#searchInput');
  const $searchResultsList = $('#searchResultsList');

  const $paginationContainer = $('#searchPagination');
  const $currentPage = $('#searchCurrentPage');
  const $totalPages = $('#searchTotalPages');
  const $prevPage = $('#searchPrevPage');
  const $nextPage = $('#searchNextPage');

  const desktopResultItemHeight = 36 + 24;
  const mobileResultItemHeight = 24 + 16;

  const mobileMaxWidth = 767;

  const storageCacheResultsKey = 'searchResults';
  const storageCachePhraseKey = 'searchPhrase';
  const storageCachePageKey = 'searchCurrentPage';

  let phrase = '';
  let results = [];

  let timeoutId;
  let request;
  let perPage;
  let totalPages;
  let currentPage;

  const calculatePerPage = () => {
    const listHeight = $searchContent.outerHeight();
    const windowHeight = $(window).innerHeight();
    const itemHeight = $(window).innerWidth() < mobileMaxWidth ? mobileResultItemHeight : desktopResultItemHeight;
    perPage = Math.floor((windowHeight - listHeight) / itemHeight) - 1;
  };


  const openSearch = (e) => {
    e.preventDefault();
    $searchContainer.addClass('show');
    $searchCloseBtn.on('click', closeSearch);
    $searchInput.focus();
    calculatePerPage();
    restoreFromCache();
  };

  const closeSearch = (e) => {
    e.preventDefault();
    $searchContainer.removeClass('show');
    $searchCloseBtn.off('click', closeSearch);
    clearCache();
  };

  const handleSearch = (e) => {
    if (request) {
      clearTimeout(timeoutId);
      request.abort();
    }

    phrase = $searchInput.val();
    if (phrase.length) {
      timeoutId = setTimeout(function () {
        request = $.ajax(searchUrl + phrase,
          {
            dataType: 'json',
            type: 'get',
            success: function (data, status, xhr) {
              results = data.data;
              setupPagination(results , 1);
              outputResults(results);
              changePage(currentPage);
            },
            error: function (jqXhr, textStatus, errorMessage) {

            }
          });
      }, 200);
    } else {
      resetSearch();
    }
    e.preventDefault();
  };

  const outputResults = (data) => {

    $searchResultsList.empty();
    data.forEach((el, i) => {
      const $li = $('<li>');
      const $a = $('<a>');
      $a.html(el.name);
      $a.attr('href', el.permalink);
      $li.append($a);
      $li.hide();
      $li.attr('data-page', Math.floor(i / perPage) + 1);
      $searchResultsList.append($li);
    });

  };

  const setupPagination = (data, cp) => {
    currentPage = cp;
    totalPages = Math.ceil(data.length / perPage);
    $totalPages.html(totalPages);
    $paginationContainer.show();

  };

  const resetSearch = () => {
    $searchResultsList.empty();
    $paginationContainer.hide();
    $searchInput.val('');

  };

  const prevPage = (e) => {
    e.preventDefault();
    if (currentPage > 1) {
      currentPage--;
      changePage(currentPage);
    }
  };

  const nextPage = (e) => {
    e.preventDefault();
    if (currentPage < totalPages) {
      currentPage++;
      changePage(currentPage);
    }
  };

  const changePage = (currentPage) => {

    $currentPage.html(currentPage);
    $searchResultsList.find(`li:not([data-page=${currentPage}])`).hide();
    $searchResultsList.find(`li[data-page=${currentPage}]`).show();
    if (currentPage === 1) {
      $prevPage.addClass('disabled');
    } else {
      $prevPage.removeClass('disabled');
    }
    if (totalPages === 1 || currentPage === totalPages) {
      $nextPage.addClass('disabled');
    } else {
      $nextPage.removeClass('disabled');
    }
  };


  const cache = () => {
    sessionStorage.setItem(storageCacheResultsKey, JSON.stringify(results));
    sessionStorage.setItem(storageCachePhraseKey, phrase);
    sessionStorage.setItem(storageCachePageKey, currentPage);
  };

  const clearCache = () => {
    resetSearch();
    sessionStorage.setItem(storageCacheResultsKey, null);
    sessionStorage.setItem(storageCachePhraseKey, null);
    sessionStorage.setItem(storageCachePageKey, null);
  };

  const restoreFromCache = () => {
    phrase = sessionStorage.getItem(storageCachePhraseKey);
    results = JSON.parse(sessionStorage.getItem(storageCacheResultsKey));
    const cp = parseInt(sessionStorage.getItem(storageCachePageKey), 10);
    if(phrase && results) {
      $searchInput.val(phrase);
      setupPagination(results, cp);
      outputResults(results);
      changePage(cp);
    }

  };

  const attachEvents = () => {
    $searchBtn.on('click', openSearch);
    $prevPage.on('click', prevPage);
    $nextPage.on('click', nextPage);

    $searchInput.on('keyup', handleSearch);
    $(document).on('click', '#searchResultsList li a', cache);
  };

  attachEvents();


};
